import { createContext, useState } from "react";

export const SendReceptDataContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [sendReceptData, setSendReceptData] = useState(null);
    const [sendReceptDatas, setSendReceptDatas] = useState([]);
    const [sendReceptDataDialog, setSendReceptDataDialog] = useState(false);
    const [sendReceptDataHistoryDialog, setSendReceptDataHistoryDialog] = useState(false);
    const [sendReceptDataHistories, setSendReceptDataHistories] = useState([]);
    const [content, setContent] = useState(null);
    const [sendReceptDataContentDialog, setSendReceptDataContentDialog] = useState(false);

    // Make the context object:
    const sendReceptDataContext = {
        sendReceptData,
        setSendReceptData,
        sendReceptDatas,
        setSendReceptDatas,
        sendReceptDataDialog,
        setSendReceptDataDialog,
        sendReceptDataHistoryDialog,
        setSendReceptDataHistoryDialog,
        sendReceptDataHistories,
        setSendReceptDataHistories,
        content, setContent,
        sendReceptDataContentDialog, setSendReceptDataContentDialog

    };

    // pass the value in provider and return
    return <SendReceptDataContext.Provider value={sendReceptDataContext}>{children}</SendReceptDataContext.Provider>;
};

export const { Consumer } = SendReceptDataContext;
